<template>
	<div class="record-table relative">
		<app-table
			class="mt-4 is-not-selectable"
			name="records"
			:clean-search="cleanSearch"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:caption-quantity="false"
			:rows="rows"
			show-record
			@on-search-event="$emit('on-search', $event)"
			@on-page="$emit('on-page', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td class="col1 is-not-selectable" v-show="showRow(columns, 1)">
					{{ props.row.id ||   null }}
				</td>
				<td v-show="showRow(columns, 2)" class="col2">
					{{props.row.customer && props.row.customer.autocomplete ? props.row.customer.autocomplete  : props.row.entityStateName || null}}
				</td>
				<td class="col4" v-show="showRow(columns, 3)">
					{{ props.row.createdAt |  exactDate }}
				</td>
				<td class="col4" v-show="showRow(columns, 4)">
					{{ props.row.documentAccountStatusId || props.row.documentNumber || (props.row.additionalInformation && props.row.additionalInformation.paymentDocumentNumber ? props.row.additionalInformation.paymentDocumentNumber : null) }}
				</td>
				<td class="col5" v-show="showRow(columns, 5)">
					<span class="reference">Referencia: </span>
					{{ props.row.amountInWords || props.row.sendKardexMessage }}
				</td>
				<td class="col6" v-show="showRow(columns, 6)">
					{{ props.row.currency }} {{ props.row.amount }}
				</td>
				<td class="col7" v-show="showRow(columns, 7)">
					<app-tooltip-button
						color="info"
						icon="remove_red_eye"
						text="Ver Detalle"
						@click-icon="goTo('records-detail', {
							params: { subsidiaryId, subsidiaryName, periodId, id: props.row.id },
							query: { periodName, CODASI: props.row.codeAccount },
						})"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	export default {
		name: 'record-list',
		components: {
			appTooltipButton,
		},
		props: {
			cleanSearch: {
				default: false,
				type: Boolean,
			},
			columns: {
				default: () => [],
				type: Array,
			},
			currentPage: {
				default: 1,
				type: Number,
			},
			lastPage: {
				default: 0,
				type: Number,
			},
			periodId: [Number, String],
			periodName: String,
			rows: {
				default: () => [],
				type: Array,
			},
			subsidiaryId: [Number, String],
			subsidiaryName: String,
		},
	};
</script>
<style lang="scss" scoped>
	.col1 {

		@media (max-width: 768px) {
			background-color: color(grey-background);
			display: flex;
			grid-column: 1/2;
			grid-row: 2;
			justify-content: center;
		}
	}

	.col2 {

		@media (max-width: 768px) {
			background-color: color(grey-background);
			display: flex;
			grid-column: 2/3;
			grid-row: 2;
			justify-content: center;
		}
	}

	.col3 {

		@media (max-width: 768px) {
			background-color: color(grey-background);
			display: flex;
			grid-column: 3/4;
			grid-row: 2;
			justify-content: center;
		}
	}

	.col6 {

		@media (max-width: 768px) {
			background-color: color(grey-background);
			display: flex;
			grid-column: 4/5;
			grid-row: 2;
			justify-content: center;
		}
	}

	.col4 {

		@media (max-width: 768px) {
			display: flex;
			grid-column: 3/4;
			grid-row: 1;
			justify-content: center;
		}
	}

	.col5 {

		@media (max-width: 768px) {
			display: flex;
			grid-column: 1/3;
			grid-row: 1;
		}
	}

	.col7 {

		@media (max-width: 768px) {
			display: flex;
			grid-column: 4/5;
			grid-row: 1;
			justify-content: center;
		}
	}

	.reference {
		display: none;

		@media (max-width: 768px) {
			display: inline-block;
			font-family: font(AvenirBold);
			margin: 0 10px;
		}
	}

	.record-table {
		margin: 0 40px;

		@media (max-width: 768px) {
			margin: 0 10px;
		}
	}

	.relative {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/records/record-list.vue